import { FC } from 'react';
import ProAlert, { AlertProps } from './alert';
import ProAlertErrorBoundary, { AlertErrorBoundaryProps } from './errorBoundary';

export type IAlterComponent = FC<AlertProps> & {
  ErrorBoundary: FC<AlertErrorBoundaryProps>,
};

const TransAlert = ProAlert as IAlterComponent;
TransAlert.ErrorBoundary = ProAlertErrorBoundary;

export default TransAlert;